import * as React from 'react'
import { AppBar as MuiAppBar, Toolbar } from '@mui/material'
import { ReactComponent as Logo } from '../../assets/brand/horizontal.svg'
import AppBarUserMenu from './components/AppBarUserMenu'
import { AppBarMenu } from 'components/app-bar'

const AppBar = () => {
  return (
    <MuiAppBar position="static" elevation={6}>
      <div className="px-8 w-full">
        <Toolbar disableGutters>
          <div className="flex-shrink-0">
            <Logo className="logo" />
          </div>

          <AppBarMenu />

          <div className="flex-grow-0">
            <AppBarUserMenu />
          </div>
        </Toolbar>
      </div>
    </MuiAppBar>
  )
}
export default AppBar
